import React from 'react'

import {
  Flex,
  Icon,
  SimpleGrid,
  Skeleton,
  Text,
  Tooltip,
  UserAvatar,
} from '@driftt/dds'
import { faCircleInfo } from '@driftt/dds.icons/light/faCircleInfo'
import {
  GANTT_DEFAULT_PAGE_SIZE,
  GanttBase,
  IAvailabilityDataElement,
  useGanttContext,
} from '@driftt/dds.reports'

const getHoursBySeconds = (seconds: number) => {
  const hours = seconds / 60 / 60
  const minutes = hours % 1
  return `${Math.trunc(hours)}h, ${Math.round(minutes * 60)}m`
}

const EmptyRows = Array.from(
  { length: GANTT_DEFAULT_PAGE_SIZE },
  (_, cellIndex) => {
    return {
      id: cellIndex,
      name: cellIndex.toString(),
      availability: 0,
      tasks: [],
      flagIndicators: [],
    } as IAvailabilityDataElement
  }
)

const SideBar = () => {
  const context = useGanttContext()
  const { displayRows, isLoading } = context

  const rows = isLoading ? EmptyRows : displayRows

  return (
    <SimpleGrid>
      <SimpleGrid css={{ paddingLeft: '1px', gridTemplateRows: '1fr 1fr' }}>
        <GanttBase.Row columns={2} type="header" />
        <GanttBase.Row columns={2} type="header">
          <GanttBase.Cell
            type="header"
            alignItems="center"
            css={{ paddingLeft: '$2' }}
          >
            {`Name`}
          </GanttBase.Cell>
          <GanttBase.Cell
            type="header"
            alignItems="center"
            justifyContent="space-between"
            css={{ paddingLeft: '$2' }}
          >
            {'Availability'}
            <Tooltip content="Amount of hours each user was available in this view (day/week)">
              <Icon
                css={{
                  marginRight: '$2',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                size="small"
                icon={faCircleInfo}
              />
            </Tooltip>
          </GanttBase.Cell>
        </GanttBase.Row>
      </SimpleGrid>

      <SimpleGrid
        css={{
          paddingTop: '1px',
          marginBottom: '1px',
          overflowX: 'scroll',
          borderLeft: '1px solid $gray3',
        }}
      >
        {rows?.map((row, cellIndex) => {
          return (
            <GanttBase.Row columns={2} key={`${row?.id}`}>
              <GanttBase.Cell
                key={`${row.id}-${cellIndex}`}
                data-row={row?.id}
                justifyContent="center"
                alignItems="center"
              >
                <Flex
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  fullHeight
                  fullWidth
                  css={{ marginLeft: '15px' }}
                >
                  <Skeleton round isLoading={isLoading} size={32}>
                    <UserAvatar size="small" name={row.name} />
                  </Skeleton>
                  <Skeleton isLoading={isLoading} height={20} width={80}>
                    <Text variant="bodyBold" css={{ textAlign: 'left' }}>
                      {row.name}
                    </Text>
                  </Skeleton>
                </Flex>
              </GanttBase.Cell>
              <GanttBase.Cell data-row={row?.id}>
                <Flex
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  fullHeight
                  fullWidth
                  gap="half"
                >
                  <Skeleton isLoading={isLoading} height={14} width={80}>
                    <Text variant="body">
                      {getHoursBySeconds(row.availability)}
                    </Text>
                  </Skeleton>
                </Flex>
              </GanttBase.Cell>
            </GanttBase.Row>
          )
        })}
      </SimpleGrid>
    </SimpleGrid>
  )
}

export default SideBar
